module.exports = new __parcel__URL__("LoomIcon.8c0f7a38.svg").toString();